import { render, staticRenderFns } from "./TopBarIcon.vue?vue&type=template&id=4f384e1c&scoped=true&"
import script from "./TopBarIcon.vue?vue&type=script&lang=js&"
export * from "./TopBarIcon.vue?vue&type=script&lang=js&"
import style0 from "./TopBarIcon.vue?vue&type=style&index=0&id=4f384e1c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f384e1c",
  null
  
)

export default component.exports